import { Factory } from 'rosie';

Factory.define('FocusModeDisabledNotification');

Factory.define('FocusModeDisabledNotificationWithDefaults')
  .extend('FocusModeDisabledNotification')
  .attr('type', 'FOCUS_MODE_DISABLED')
  .attr('id', 'example-focusModeDisabled-notification-id');
